import { ReactNode, useState } from "react";
import FlagQuestionModal from "../../components/Modal/FlagQuestionModal";
import { Button as BootstrapButton, Button } from "react-bootstrap";
import { IoIosCheckmarkCircle } from "react-icons/io";
// import Button from "../../components/Button/Button";
import {
  BsArrowLeftCircleFill,
  BsArrowRightCircleFill,
  BsFlag,
  BsStar,
  BsStarFill,
} from "react-icons/bs";
import { Question } from "../../types";

export const AssignmentPageTitle = (props: {
  questionNumber: number;
  question: Question;
  totalQuestions: number;
  isAssignmentMode: boolean;
  submitAssignment?: () => void;
  onNextQuestionClicked?: () => void;
  nextQuestionButtonDisabled?: boolean;
  onPreviousQuestionClicked?: () => void;
  prevQuestionButtonDisabled?: boolean;
  currentQuestionIndex?: number;
  // onSkipQuestionClicked?: () => void;
  handleStarQuestion?: () => void;
  leftExtra?: ReactNode;
  rightExtra?: ReactNode;
  isStarred?: boolean;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleShowModal = () => setShowModal(true);
  return (
    <div className="assignment-page-title">
      <div className="assignment-page-title__left">
        <h4>
          Question {props.questionNumber} of {props.totalQuestions}
        </h4>

        {props.handleStarQuestion && (
          <button
            type="button"
            className="assignment-page-title__icon-btn"
            onClick={props.handleStarQuestion}
          >
            {(props.isStarred ?? (props.question.starredBy.length > 0)) ? (
              <BsStarFill color="orange" aria-hidden="true" />
            ) : (
              <BsStar color="orange" aria-hidden="true" />
            )}
          </button>
        )}

        <button
          type="button"
          className="assignment-page-title__icon-btn assignment-page-title__flag-btn"
          onClick={handleShowModal}
        >
          <BsFlag color="red" aria-hidden="true" />
        </button>
      </div>

      <div className="assignment-page-title__right">
        {props.rightExtra ? (
          <div className="assignment-page-title__extra">{props.rightExtra}</div>
        ) : null}
        {props.isAssignmentMode ? (
          <BootstrapButton
            variant="dark"
            size="sm"
            className="small"
            onClick={props.submitAssignment}
            style={
              {
                // fontSize: '0.9rem'
              }
            }
          >
            Submit Exam <IoIosCheckmarkCircle />
          </BootstrapButton>
        ) : undefined}

        {props.leftExtra ? (
          <div className="assignment-page-title__extra">{props.leftExtra}</div>
        ) : null}

        <button
          type="button"
          className="assignment-page-title__nav-btn"
          onClick={props.onPreviousQuestionClicked}
          disabled={props.prevQuestionButtonDisabled}
        >
          <BsArrowLeftCircleFill
            size={22}
            color={props.prevQuestionButtonDisabled ? "grey" : "#0d6efd"}
            aria-hidden="true"
          />
        </button>

        <button
          type="button"
          className="assignment-page-title__nav-btn"
          onClick={props.onNextQuestionClicked}
          disabled={props.nextQuestionButtonDisabled}
        >
          <BsArrowRightCircleFill
            size={22}
            color={props.nextQuestionButtonDisabled ? "grey" : "#0d6efd"}
            aria-hidden="true"
          />
        </button>
      </div>

      <FlagQuestionModal
        setShowModal={setShowModal}
        showModal={showModal}
        questionId={props.question.id}
      ></FlagQuestionModal>
    </div>
  );
};
